/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ToggleCheckbox from '../Controls/ToggleCheckbox';
import SelectFilter from './SelectFilter';
import i18n from '../../i18n/translate';

const ToggleFilter = (props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(props.value);
  }, [props.value]);

  const CustomOption = ({ innerRef, innerProps, props }) => {
    return <ToggleCheckbox ref={innerRef} {...innerProps} {...props} className="round sm" label={getOptions()[0].label} leftToggle={true} checked={checked} onChange={onChange} />
  };

  CustomOption.propTypes = {
    innerRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.any })
    ]),
    innerProps: PropTypes.object,
    props: PropTypes.object
  }

  const getOptionLabel = () => {
    let label = '';
    if (checked) {
      label = props.checkedLabel || `${i18n.t('Filtering by')} ${props.label}`;
    } else {
      label = props.uncheckedLabel || `${i18n.t('Not Filtering by')} ${props.label}`;
    }

    return label;
  }

  const getOptions = () => {
    return [ { id: checked, label: getOptionLabel() }];
  }

  const onChange = () => {
    setChecked(prevChecked =>  !prevChecked);
  }

  return (
    <div className="toggle-filter">
      <SelectFilter
        customComponent={{ Option: CustomOption }}
        clearable={false}
        {...props}
        options={getOptions()}
      />
    </div>
  );
};

ToggleFilter.propTypes = {
  checkedLabel: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  uncheckedLabel: PropTypes.string,
  value: PropTypes.bool
};

export default ToggleFilter;
